<template>
  <div>
    <div>
      <!-- <div class="ta-r mb-10" style="margin-right: 1%;" v-if="!loading && list.length && userData && userData.userId">
        <el-button type="success" @click="doSyncAll" :loading="isSyncAllLoading">同步该用户所有帖子</el-button>
      </div> -->
      <el-skeleton style="width:100%" class="flex wrap postListBox" :loading="loading" animated >
        <template slot="template">
          <div class="flex wrap postListBox">
            <div class="postBox" v-for="(item, index) in 5" :key="index">
              <el-card :body-style="{ padding: '0px' }">
                <el-skeleton-item variant="image" animated :throttle="500" style="width: 100%;height:200px" />
                <div style="padding: 14px;">
                  <el-skeleton-item variant="p" animated :throttle="500" style="width: 50%" />
                  <div style="display: flex; align-items: center; justify-items: space-between;">
                    <el-skeleton-item variant="text" animated :throttle="500" style="margin-right: 16px;" />
                    <el-skeleton-item variant="text" animated :throttle="500" style="width: 30%;" />
                  </div>
                </div>
              </el-card>
            </div>
          </div>
        </template>
        <template>
          
          <div v-for="(item, index) in list" :key="index" class="postBox">
            <el-card :body-style="{ padding: '0px' }">
              <Resources :list="item.resources"/>

              <div class="content-box">
                <div class="title">{{item.title}}</div>
                <div class="description">{{item.contents}}</div>
                <div class="bottom clearfix">
                  <time class="time">发布日期 {{ item.publishDate }}</time>
                </div>
                <div v-if="userData && userData.userId">
                  <el-divider></el-divider>
                  <div class="ta-r">
                    <el-button round type="success" class="button" size="mini" :loading="isSyncIdLoading == item.extPostId"  @click="doSyncById(item)">同步</el-button>
                  </div>
                </div>
              </div>
              
            </el-card>
          </div>
        </template>
      </el-skeleton>
    </div>
    

    <div class="ta-c mt-10 mb-10">
      <el-button style="width:60%" :loading="nextLoading" v-if="hasNext" @click="doChangePage(page+1)">加载更多</el-button>
      <el-pagination
        background
        hide-on-single-page
        layout="prev, pager, next"
        @current-change="doChangePage"
        :page-size="size"
        :current-page="page"
        :total="total">
      </el-pagination>
    </div>
    
  </div>
</template>

<script>
import Resources from '@/components/Resources';
export default {
  name: 'PostList',
  components: {
    Resources
  },
  props: {
    userData:Object,
    collectUserId: String,
    collectType: String,
    extension: Object,
    updateTimer:{
      type: Number,
      default: null,
    },
  },
  data(){
    
    return {
      total:0,
      page:1,
      size:6,
      loading:true,
      nextLoading:true,
      list:[],
      isSyncAllLoading:false,
      isSyncIdLoading:0,
      hasNext:true,
      afterCursor:""
    }
  },
  created () {
    this.load();
  },
  watch: {
    collectUserId(){
      this.load();
    },
    updateTimer(){
      this.load();
    }
  },
  methods:{
    checkSyncType(){
      if(!this.userData.slowLifeUserId){
        this.$message.warning("请先关联喜悦汇名人");
        return false;
      }
      if(!this.extension.se || !this.extension.se.syncType || this.extension.se.syncType == 'NONE'){
        this.$message.warning("请先设置 自动发布配置");
        return false;
      }
      return true;
    },
    doSyncAll(){
      if(!this.checkSyncType()){
        return ;
      }
      this.isSyncAllLoading = true;
      this.request.post(`/api/v1/postings/syncing/all`,{userId:this.userData.userId}).then(res=>{

        this.isSyncAllLoading = false;
        if(!res){return ;}
        this.$message.success("同步全部帖子成功!");
      }).catch(error=>{
        this.isSyncAllLoading = false;
        this.$message.error("返回超时,请稍候再试!");
        console.log(error);
      });
    },
    doSyncById(item){
      if(!this.checkSyncType()){
        return ;
      }
      this.isSyncIdLoading = item.postingId;
      var params = {userId:this.userData.userId,...item};
      this.request.post(`/api/v1/postings`,params).then(res=>{
      // this.request.post(`/api/v1/postings/syncing/${postingId}`,{postingId}).then(res=>{
        this.isSyncIdLoading = 0;
        if(!res){return ;}
        this.$message.success("同步帖子成功!");
      })
    },
    load(){
      this.loading = true;
      this.page = 1;
      this.afterCursor = "";
      this.list = [];
      this.hasNext = false;
      var url = `/api/v1/collects/posts?collectType=${this.collectType}&collectUserId=${this.collectUserId}&page=${this.page}&nextPage=${this.page}&size=${this.size}&afterCursor=${this.afterCursor}`;
      this.getList(url);
    },
    getList(url){
      this.nextLoading = true;
      this.request.get(url).then(res=>{
        this.loading = false;
        this.nextLoading = false;
        // this.list = [];
        this.afterCursor = "";
        if(!res){return ;}
        
        
        if(this.collectType == 'INS'){
          this.list = this.list.concat(res.results);
          this.afterCursor = res.afterCursor;
          this.hasNext = !!this.afterCursor;
        } else {
          this.list = res.results;
          this.total = res.total;
          this.page = res.currentPage;
        }
        
      });
    },
    doChangePage(currentPage){
      this.page = currentPage;
      if(this.collectType == 'XHS'){
        this.loading = true;
      }
      var url = `/api/v1/collects/posts?collectType=${this.collectType}&collectUserId=${this.collectUserId}&page=${currentPage}&nextPage=${this.page}&size=${this.size}&afterCursor=${this.afterCursor}`;
      this.getList(url);
    },
  } 
}
</script>

<style lang="less" scoped>
.thumb-box{
  width:100%;
}
.content-box {
  padding: 14px;
  .title{
    font-size:14px;
  }
  .description{
    font-size:12px;
  }
  .bottom{
    margin-top:5px;
    margin-bottom:5px;
    .button{
      float: right;
    }
  }
}

.postListBox{
  .postBox{
    width:30%;
    margin-left:3%;
    margin-bottom:3%;  
  }
}
</style>
